import React from 'react'
import type { PageQuery } from './SearchTable'
import '../order/Order.css'

export const SortableHeader = ({ field, query, onSort, children, className, as: Tag = 'div' }: {
  field: string
  query: Pick<PageQuery, 'sortBy' | 'sortDirection'>
  onSort: (field: string) => void
  children: React.ReactNode
  as?: 'div' | 'th'
  className?: string
}) => {
  const active = query.sortBy === field
  return <Tag className={`${className ?? (Tag === 'div' ? 'hcol' : '')} sortable-header`} role='columnheader'
    onClick={() => onSort(field)}
    aria-sort={active ? (query.sortDirection === 'desc' ? 'descending' : 'ascending') : 'none'}>
    <button type='button' className='sort-header-button'>
      {children}
      {active && <span aria-hidden='true' className={`order-info ${query.sortDirection === 'desc' ? 'order-info-desc' : 'order-info-asc'}`}>
        <i className='svgfont-arrow-up' />
      </span>}
    </button>
  </Tag>
}
